__turbopack_context__.v({
  "brandList": "styles-module__A0zBkq__brandList",
  "brandListHeader": "styles-module__A0zBkq__brandListHeader",
  "brandListItem": "styles-module__A0zBkq__brandListItem",
  "brandListLink": "styles-module__A0zBkq__brandListLink",
});
